import React from 'react';
import { Routes } from 'react-router';
import Well from 'components/UI/Containers/Well';
import { Route } from 'react-router-dom';
import UnauthorizedPage from 'components/Pages/UnauthorizedPage';
import GuestLayout from 'components/Components/GuestLayout';
import AuthLayout from 'components/Components/AuthLayout';
import { ROUTING } from 'constants/routing';
import HomePage from 'components/Pages/HomePage';
import AboutUsPage from 'components/Pages/AboutUsPage';
import Profile from 'components/Pages/Profile';
import ReservationsTablePage from 'components/Pages/ReservationsTablePage';
import Requests from 'components/Pages/Requests';
import Reports from 'components/Pages/Reports';
import Alerts from 'components/Pages/Alerts';
import ReservationPage from 'components/Pages/ReservationPage';
import RequestPage from 'components/Pages/RequestPage';
import AuthorizeAccess from 'components/Components/AuthorizeAccess';
import SignUpPage from 'components/Pages/SignUpPage';
import PageNotFound from 'components/Pages/PageNotFound';
import ForgotPasswordPage from 'components/Pages/ForgotPasswordPage';
import ResetPasswordPage from 'components/Pages/ResetPasswordPage';
import AuthorizationCallback from 'components/Pages/AuthorizationCallback';
function B2BApp()
{
    return (
        <Well>

            <Routes>

                <Route path="/" element={<AuthLayout />}>
                    <Route key={ROUTING.HOME} path={ROUTING.HOME} element={<AuthorizeAccess component={HomePage} />} />
                    <Route key={ROUTING.ABOUT_US} path={ROUTING.ABOUT_US} element={<AuthorizeAccess component={AboutUsPage} />} />
                    <Route key={ROUTING.PROFILE} path={ROUTING.PROFILE} element={<AuthorizeAccess component={Profile} />} />
                    <Route key={ROUTING.AUTHORIZATION_CALLBACK} path={ROUTING.AUTHORIZATION_CALLBACK} element={<AuthorizeAccess component={AuthorizationCallback} />} />
                    <Route key={ROUTING.REQUESTS} path={ROUTING.REQUESTS} element={<AuthorizeAccess component={Requests} />} />
                    <Route key={ROUTING.REPORTS} path={ROUTING.REPORTS} element={<AuthorizeAccess component={Reports} />} />
                    <Route key={ROUTING.ALERTS} path={ROUTING.ALERTS} element={<AuthorizeAccess component={Alerts} />} />
                    <Route key={ROUTING.REQUEST_PAGE} path={ROUTING.REQUEST_PAGE} element={<AuthorizeAccess component={RequestPage} />} />
                    <Route key={ROUTING.RESERVATIONS} path={ROUTING.RESERVATIONS} element={<AuthorizeAccess component={ReservationsTablePage} />} />
                    <Route key={ROUTING.RESERVATION_PAGE} path={ROUTING.RESERVATION_PAGE} element={<AuthorizeAccess component={ReservationPage} />} />
                </Route>

                <Route path="/" element={<GuestLayout />}>
                    <Route key={ROUTING.UNAUTHORIZE} path={ROUTING.UNAUTHORIZE} element={<UnauthorizedPage />} />
                    <Route key={ROUTING.SIGN_UP} path={ROUTING.SIGN_UP} element={<SignUpPage />} />
                    <Route key={ROUTING.FORGOT_PASSWORD} path={ROUTING.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
                    <Route key={ROUTING.RESET_PASSWORD} path={ROUTING.RESET_PASSWORD} element={<ResetPasswordPage />} />
                </Route>
                <Route path="*" element={<PageNotFound />} />

            </Routes>

        </Well>
    );
}
export default B2BApp;
